module.exports = __webpack_public_path__ + "img/line-add-friend-zh.49653b4c.png";